<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/test@2x.png"/>
              <div class="media-body">
                <h1>{{examInfo.title}}</h1>
                <div>
                  <span class="gray">유형</span> {{examInfo.exam_type_name}}  ·  <span class="gray">응시 인원 </span> <span class="number">{{examInfo.exam_user_cnt}}</span>  · <span class="gray">공개 여부</span>
                  {{examInfo.stat_name}}  ·
                  <span class="gray">카테고리</span> {{examInfo.cate_path}}
                  <br />
                  <span class="gray">생성일</span> {{this.formatterDate(examInfo.reg_dt)}}
                  <template v-if="examInfo.open_dt !== ''">·  <span class="gray">공개일</span> {{this.formatterDate(examInfo.open_dt)}}</template>
                  <template v-if="examInfo.close_dt !== '' && examInfo.close_dt !== '-'">·  <span class="gray">종료일</span> {{this.formatterDate(examInfo.close_dt)}}</template>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="p-2 ml-auto button-group">
            <el-button class="excel" :loading="excelLoading" @click="handlerExcel"><i class="fas fa-file-excel"></i></el-button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>문제 <span class="number mint">{{tableData.length}}</span></h2>
          </div>
          <div class="ml-auto p-2">
            <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading"></excel>
          </div>
        </div>
      </div>
      <stone-data-table
        ref="stoneDataTable"
        :loading="searchLoading"
        :columns="tableColumns"
        :data="tableData"
        :table-props="tableProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps">
      </stone-data-table>
    </div>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M070202',
  mixins: [common.mixins],
  data () {
    return {
      examInfo: {
        exam_seq: 0,
        exam_paper_seq: 0,
        exam_paper_title: '',
        cate_path: '',
        cate_code: '',
        curriculum_seq: '',
        curriculum_name: '',
        quiz_cnt: '',
        exam_type: '',
        exam_type_name: '',
        title: '',
        content: '',
        reg_dt: '',
        open_dt: '',
        close_dt: '',
        exam_term: '',
        stat_name: '',
        stat: '',
        exam_user_cnt: 0,
        exam_class_cnt: 0
      },
      tableData: [],
      tableColumns: [
        {label: '문제번호', align: 'center', prop: 'display_no', width: 70},
        {label: '영역', prop: 'group_cate_code_name', align: 'center', width: 60},
        {label: '유형', prop: 'cate_code_name', align: 'left', width: 200},
        {label: '정답', prop: 'solution', align: 'center', width: 50, sortable: false},
        {label: '최다오답', prop: 'max_wrong', align: 'center', width: 50, sortable: false},
        {label: '선택지',
          group: [
            {label: '1', prop: 'answer_reaction_01_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'},
            {label: '2', prop: 'answer_reaction_02_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'},
            {label: '3', prop: 'answer_reaction_03_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'},
            {label: '4', prop: 'answer_reaction_04_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'},
            {label: '5', prop: 'answer_reaction_05_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'}
          ]},
        {label: '정답률', prop: 'solution_rate', align: 'right', formatter: this.columnFormatterRate, width: 50, dataType: 'percentage', format: '0.0%'}
      ],
      tableProps: {height: this.getScreenHeight(31)}
    }
  },
  beforeCreate () {
  },
  created () {
    const examSeq = this.$route.params.exam_seq
    if (examSeq && examSeq !== 0) {
      this.loadInfo(examSeq)
    } else {
      this.$router.push({name: 'M070201'})
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo (examSeq) {
      this.loadStoneDataTable('/stats/quiz/' + examSeq, null, false)
        .then(response => {
          const result = response.data
          // console.log(result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })
          this.tableData = result.exam_quiz
        })
    },
    downloadExcel () {
      const headers = []
      headers.push(this.getExcelColumns(this.tableColumns, true))
      const excelColumns = this.getExcelColumns(this.tableColumns, false)
      headers.push(excelColumns)
      // console.log('headers : ', headers)
      const param = {
        data: {
          service: 'ExamStatisticsService',
          method: 'selectEaxmQuizResult',
          params: {exam_seq: this.examInfo.exam_seq}
        },
        excel: {
          header: headers,
          columns: excelColumns,
          file: this.examInfo.title
        }
      }
      // console.log('param : ', param)
      this.exportExcel(param)
    },
    getExcelColumns (list, isGroup) {
      const columns = []
      list.forEach(col => {
        const obj1 = Object.assign({}, col)
        if (obj1.group) {
          obj1.group.forEach((group, idx) => {
            const obj2 = Object.assign({}, group)
            obj2.colSpan = isGroup && idx === 0 ? obj1.group.length : 1
            obj2.rowSpan = 1
            obj2.label = isGroup ? obj1.label : group.label
            columns.push(obj2)
          })
        } else {
          obj1.colSpan = 1
          obj1.rowSpan = isGroup ? 2 : 1
          columns.push(obj1)
        }
      })
      return columns
    }
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/M070202.vue